const businessLabels: Record<string, string> = {
  PENDING_PAYMENT: '待付款',
  PAID: '已支付',
  FULFILLING: '处理中',
  COMPLETED: '已完成',
  CANCELLED: '已取消',
  REFUNDED: '已退款',
  REFUND_PENDING: '退款待审核',
  APPROVED: '已通过',
  REJECTED: '已驳回',
  PENDING: '待确认',
  CONFIRMED: '已确认',
  ARRIVED: '已到店',
  AVAILABLE: '空闲',
  RESERVED: '已预约',
  OCCUPIED: '使用中',
  BOOKABLE: '可预约',
  WALK_IN: '仅线下',
  LOCKED: '锁定',
  HELD: '后台预留',
  ACTIVE: '启用中',
  PAUSED: '已暂停',
  EXPIRED: '已过期',
  DRAFT: '草稿',
  ENDED: '已结束',
  PUBLISHED: '已发布',
  HIDDEN: '已隐藏',
  PROCESSING: '处理中',
  FAILED: '失败',
  INCOME: '收入',
  EXPENSE: '支出',
  CREDIT: '增加',
  DEBIT: '减少',
  CENTER: '领券中心',
  TARGETED: '定向发送',
  WECHAT: '微信支付',
  BALANCE: '余额支付',
  OFFLINE: '线下支付',
  BOOKING: '预约选座',
  DINING: '堂食点单',
  SHOP: '商城',
  RECHARGE: '充值储值',
  AI_IMAGE: 'AI 拼豆生图',
  CUSTOMER: '顾客',
  STAFF: '员工',
  ADMIN: '管理员',
}

export const businessLabel = (value: unknown) => {
  const text = String(value)
  return businessLabels[text] ?? text
}
